<template>
  <div id="history-screen">
    <div class="row">
      <div class="col-8 placement-column">
        <div class="row">
          <div class="col-12">
            <h1 class="page-title">{{ $t("pages.title.history") }}</h1>
          </div>
        </div>
        <div class="row pager-row">
          <sequence-pager
            :value="pagerValue"
            @back="previousMonth"
            @forward="nextMonth"
          />
        </div>
        <div
          class="row no-gutters"
          v-for="(placement, index) in history"
          :key="index"
        >
          <div :class="`placement-item basic-box placement-${index}`">
            <div class="placement-number">{{ placement.place }}.</div>
            <div class="user-image-wrapper">
              <user-image :user="placement.user" class="user-image" />
            </div>
            <div
              v-if="
                loggedInUserProfile.role === 1 ||
                loggedInUserProfile.company.privacyLevel === 0
              "
              class="text"
              v-html="
                $t('history.listItem.text', {
                  name: placement.user.userName,
                  income: placement.subBalance.income,
                  place: placement.place,
                })
              "
            ></div>
            <div
              v-else
              class="text"
              v-html="
                $t('history.listItem.textSimple', {
                  name: placement.user.userName,
                  place: placement.place,
                })
              "
            ></div>
          </div>
        </div>
        <div v-if="history.length < 1" class="empty-list">
          {{ $t("history.list.empty") }}
        </div>
      </div>
      <div class="col-4">
        <div class="title">
          <h1 class="page-title">{{ $t("history.popularReasons.title") }}</h1>
        </div>
        <div class="row" v-for="(reason, index) in reasons" :key="index">
          <div class="col-12">
            <div class="basic-box popular-reason">
              <div class="reason">"{{ reason._id }}"</div>
              <div
                v-if="
                  loggedInUserProfile.role === 1 ||
                  loggedInUserProfile.company.privacyLevel === 0
                "
                class="counts"
                v-html="
                  $t('history.popularReasons.counters', {
                    totalAmount: reason.totalAmount,
                    count: reason.count,
                  })
                "
              ></div>
              <div
                v-else
                class="counts"
                v-html="
                  $t('history.popularReasons.countersSimple', {
                    count: reason.count,
                  })
                "
              ></div>
            </div>
          </div>
        </div>
        <div class="row" v-if="reasons.length == 0">
          <div class="empty-reasons">
            {{ $t("history.reasons.empty.title") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SequencePager from "@/components/shared/elements/SequencePager";
import UserImage from "@/components/shared/users/UserImage";

export default {
  name: "HistoryScreen",
  components: {
    SequencePager,
    UserImage,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      reasons: [],
      history: [],
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters({
      loggedInUserProfile: "users/loggedInUserProfile",
    }),
    pagerValue() {
      return `${this.year}/${this.formattedMonth}`;
    },
    formattedMonth() {
      const monthNumber = Number(this.month) + 1;
      let s = String(monthNumber);
      while (s.length < 2) {
        s = `0${s}`;
      }
      return s;
    },
  },
  methods: {
    ...mapActions({
      fetchPopularReasons: "transactions/popularReasons",
      fetchHistoryByMonth: "histories/fetchHistoryByMonth",
    }),
    async fetchData() {
      this.reasons = await this.fetchPopularReasons({
        year: this.year,
        month: this.month,
      });
      this.history = await this.fetchHistoryByMonth({
        year: this.year,
        month: this.month,
      });
      this.$gtag.event('history', {
        year: this.year,
        month: this.month,
      });
    },
    previousMonth() {
      if (this.month === 0) {
        this.year -= 1;
        this.month = 11;
      } else {
        this.month -= 1;
      }
      this.fetchData();
    },
    nextMonth() {
      if (this.month === 11) {
        this.year += 1;
        this.month = 0;
      } else {
        this.month += 1;
      }
      this.fetchData();
    },
  },
};
</script>

<style lang="scss" scoped>
#history-screen {
  padding: 0 3%;
  .popular-reason {
    margin: 10px !important;
    .reason {
      color: $primary-color;
      font-style: italic;
      min-height: 60px;
      text-align: left;
      display: flex;
      align-items: center;
    }
    .counts {
      font-size: 10px;
      color: #999;
      >>> b {
        color: $primary-color;
        font-weight: bolder;
      }
    }
  }
  .pager-row {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }
  .empty-list {
    font-size: 25px;
    background-color: rgba(250, 250, 250, 1);
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    margin: 20px;
  }
  .empty-reasons {
    background-color: rgba(250, 250, 250, 1);
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    margin: 20px;
  }
  .placement-column {
    .placement-item {
      &.placement-0 {
        background: rgb(51, 128, 195);
        background: linear-gradient(
          90deg,
          rgba(51, 128, 195, 1) 0%,
          rgba(98, 45, 144, 1) 49%
        );
        font-size: 20px;
        color: white;
        margin: 10px 20px;
        .user-image-wrapper {
          width: 65px;
          height: 65px;
        }
      }
      margin: 10px 40px;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      .placement-number {
        font-size: 20px;
        margin: 0px 20px;
      }
      .user-image-wrapper {
        width: 45px;
        height: 45px;
        >>> img {
          vertical-align: super;
        }
      }
      .text {
        margin-left: 20px;
      }
    }
  }
}
</style>
